import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const productsStartRequest = () => {
  return {
    type: 'PRODUCTS_START_REQUEST'
  };
};

export const productsEndRequest = () => {
  return {
    type: 'PRODUCTS_END_REQUEST'
  };
};

export const getAllProductsSuccess = ({ data }) => {
  return {
    type: 'PRODUCTS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllProductsError = error => {
  return {
    type: 'PRODUCTS_GET_ALL_ERROR',
    payload: error
  };
};

export const addProductsSuccess = ({ data }) => {
  return {
    type: 'PRODUCTS_ADD_SUCCESS',
    payload: data
  };
};

export const addProductsError = error => {
  return {
    type: 'PRODUCTS_ADD_ERROR',
    payload: error
  };
};

export const editProductsSuccess = ({ data }) => {
  return {
    type: 'PRODUCTS_EDIT_SUCCESS',
    payload: data
  };
};

export const editProductsError = error => {
  return {
    type: 'PRODUCTS_EDIT_ERROR',
    payload: error
  };
};

export const removeProductsSuccess = id => {
  return {
    type: 'PRODUCTS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeProductsError = error => {
  return {
    type: 'PRODUCTS_REMOVE_ERROR',
    payload: error
  };
};

export const productsModifyStore = ({ data }) => {
  return {
    type: 'PRODUCTS_MODIFY_STORE',
    payload: data
  };
};

export const addProducts = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(productsStartRequest());
      const response = await api().post('/api/products', {
        ...data,
        image: undefined
      });
      if (data.image) {
        const formData = new FormData();
        formData.append('image', data.image);
        formData.append('product', response.data._id);
        await api().post('/api/products/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      dispatch(addProductsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'products',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addProductsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(productsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllProducts = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(productsStartRequest());
      const response = await api().get('/api/products', { params });
      dispatch(getAllProductsSuccess(response));
    } catch (err) {
      dispatch(getAllProductsError(err));
    } finally {
      dispatch(productsEndRequest());
    }
  };
};

export const editProducts = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(productsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(productsStartRequest());
      const id = data._id;
      const response = await api().put('/api/products/' + id, {
        ...data,
        image: undefined
      });
      if (data.image) {
        const formData = new FormData();
        formData.append('image', data.image);
        formData.append('product', response.data._id);
        await api().post('/api/products/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      dispatch(editProductsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'products',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/products'));
      }
    } catch (err) {
      dispatch(editProductsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeProducts = id => {
  return async dispatch => {
    try {
      dispatch(productsStartRequest());
      await api().delete('/api/products/' + id);
      dispatch(removeProductsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'products',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Produto removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeProductsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover produto.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(productsEndRequest());
    }
  };
};

export const restoreProducts = data => {
  return async dispatch => {
    try {
      dispatch(productsStartRequest());
      const id = data._id;
      const response = await api().put('/api/products/' + id, data);
      dispatch(editProductsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'products',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Produto restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editProductsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar produto.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(productsEndRequest());
    }
  };
};
